import { useState, useEffect } from 'react';
import LinePlot from "../line-plot/line-plot.component";
import BarPlot from "../bar-plot/bar-plot.component";
import EmbeddingsPlot from '../embeddings-plot/embeddings-plot.component';
import { isEmpty } from '../../assets/constants';
import SvgPlotWrapper from "../svg-plot-wrapper/svg-plot-wrapper.component";
import LogoWithText from "../logo-with-text/logo-with-text.component";
import MiniPlot from '../mini-plot/mini-plot.component';

const formatSimilarDataAsSurveyResponse = (similarQuestionData, selectedEmbeddingIndex, closestTextsAndOptions) => {
    if (selectedEmbeddingIndex === null || selectedEmbeddingIndex < 0) return {};
    let surveyResponse = {}
    const surveyAnswers = closestTextsAndOptions[selectedEmbeddingIndex]['options'];
    surveyResponse['surveyAnswers'] = surveyAnswers;
    const similarData = similarQuestionData[selectedEmbeddingIndex];
    surveyResponse['surveyData'] = similarData;
    // Get minimum and maximum years
    // Check if 'year' is a key in the first entry
    if (similarData[0].hasOwnProperty('year')) {
        const years = similarData.map(d => d['year']);
        surveyResponse['surveyYears'] = [Math.min(...years), Math.max(...years)];
    }
    // Get unique responses from first entry
    return surveyResponse;
}

const getIsPanel = (surveyResponse) => {
    if (isEmpty(surveyResponse)) return true;
    // If no surveyYears is undefined, return false
    if (surveyResponse['surveyYears'] === undefined) return false;
    // console.log('surveyResponse', surveyResponse)
    const surveyYears = surveyResponse['surveyYears'];
    if (surveyYears[0] === surveyYears[1]) return false;
    return true;
}

const InvestigationsPlot = ({
    embeddingData,
    dimensions,
    isSmall,
    isMedium,
    selectedEmbeddingIndex,
    shownQuestionIndices,
    similarQuestionData,
    hasMouse,
    similarDataPlotPrimary,
    closestTextsAndOptions,
    isFittingTSNE,
    model
}) => {
    const [surveyResponse, setSurveyResponse] = useState({});
    const [similarDataIsPanel, setSimilarDataIsPanel] = useState(true);

    useEffect(() => {
        const newSurveyResponse = formatSimilarDataAsSurveyResponse(similarQuestionData, selectedEmbeddingIndex, closestTextsAndOptions);
        setSurveyResponse(newSurveyResponse);
        const newIsPanel = getIsPanel(newSurveyResponse);
        setSimilarDataIsPanel(newIsPanel);
    }, [similarQuestionData, selectedEmbeddingIndex]);

    const showingSimilarData = similarQuestionData.length > 0 && selectedEmbeddingIndex !== null && selectedEmbeddingIndex >= 0;

    return (
        <>
            {
                similarDataPlotPrimary === false ?
                    <EmbeddingsPlot
                        embeddingData={embeddingData}
                        dimensions={dimensions}
                        isMedium={isMedium}
                        selectedEmbeddingIndex={selectedEmbeddingIndex}
                        shownQuestionIndices={shownQuestionIndices}
                    />
                    :
                    showingSimilarData && (!isEmpty(surveyResponse)) ?
                        similarDataIsPanel ?
                            <LinePlot
                                dimensions={dimensions}
                                surveyResponse={surveyResponse}
                                isSmall={isSmall}
                                isMedium={isMedium}
                                animateTransition={false}
                                hasMouse={hasMouse}
                                plotType='raw'
                            />
                            :
                            <BarPlot
                                dimensions={dimensions}
                                surveyResponse={surveyResponse}
                                isSmall={isSmall}
                                isMedium={isMedium}
                                animateTransition={false}
                                hasMouse={hasMouse}
                                plotType='raw'
                            />
                        :
                        <SvgPlotWrapper dimensions={dimensions}>
                            <LogoWithText innerWidth={dimensions.innerWidth} innerHeight={dimensions.innerHeight} />
                        </SvgPlotWrapper>
            }
            {
                isFittingTSNE === false &&
                <MiniPlot
                    dimensions={dimensions}
                    embeddingData={embeddingData}
                    selectedEmbeddingIndex={selectedEmbeddingIndex}
                    similarQuestionData={similarQuestionData}
                    isShowingTSNE={similarDataPlotPrimary}
                    shownQuestionIndices={shownQuestionIndices}
                />
            }
        </>)
}

export default InvestigationsPlot;

// Add options to plot hover tooltip
// Add year to bar plot
// Send to Mayank!